import React, { Fragment, useState, useEffect } from "react";
import { TextField, MenuItem, Select, InputLabel } from "@material-ui/core";
import PickupSelector from "../giftshop/PickupSelector";
import CollapsedContainer from "../assets/CollapsedContainer";
import Loading from "../assets/Loading";
import Modal from "../assets/Modal";
import {
  ApplePay,
  CreditCard,
  GiftCard,
  GooglePay,
  PaymentForm as SquarePaymentForm,
} from "react-square-web-payments-sdk";
import OutlinedInput from "@mui/material/OutlinedInput";
import FormControl from "@mui/material/FormControl";

const development =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";
const appId = development
  ? "sandbox-sq0idb-X_YG4ZeQm5yeVXAaEjH9Aw"
  : "sq0idp-Zt66ubgBvwkuijlDQBQGpQ";
const locationId = development ? "1D1W0QXPXSXTF" : "EENN0H8C8XBVN";

const states = {
  AK: "Alaska",
  AL: "Alabama",
  AR: "Arkansas",
  AS: "American Samoa",
  AZ: "Arizona",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DC: "District of Columbia",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  GU: "Guam",
  HI: "Hawaii",
  IA: "Iowa",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  MA: "Massachusetts",
  MD: "Maryland",
  ME: "Maine",
  MI: "Michigan",
  MN: "Minnesota",
  MO: "Missouri",
  MS: "Mississippi",
  MT: "Montana",
  NC: "North Carolina",
  ND: " North Dakota",
  NE: "Nebraska",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NV: "Nevada",
  NY: "New York",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  PR: "Puerto Rico",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VA: "Virginia",
  VI: "Virgin Islands",
  VT: "Vermont",
  WA: "Washington",
  WI: "Wisconsin",
  WV: "West Virginia",
  WY: "Wyoming",
};
const CREDIT_CARD = "Credit Card";
const GIFT_CARD = "Gift Card";
const APPLY_PAY = "Apple Pay";
const GOOGLE_WALLET = "Google Wallet";

const AllowedPaymentOptions = [CREDIT_CARD, GIFT_CARD, GOOGLE_WALLET];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const PaymentOptionProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

class PaymentForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      card: null,
      disabled: false,
      status: null,
      statusBarHidden: true,
      fullfilment: {
        type: this.props.isPickup ? "PICKUP" : "SHIPMENT",
        state: "PROPOSED",
        shipment_details: { recipient: {} },
        pickup_details: { recipient: {}, pickup_at: "" },
      },
      address_line_1: "",
      address_line_2: "",
      locality: "",
      sublocality: "",
      postal_code: "",
      isLoading: false,
      orderTotal: props.total,
      remainingBalance: props.total,
      incompletePayment: false,
      orderId: null,
      paymentType: "Credit Card",
      error: null,
    };

    this.handlePaymentOptionChange = this.handlePaymentOptionChange.bind(this);
    this.clearError = this.clearError.bind(this);
    this.setError = this.setError.bind(this);
  }

  async componentDidMount() {}

  componentDidUpdate(prevProps) {
    if (prevProps.total !== this.props.total) {
      this.setState({
        orderTotal: this.props.total,
        remainingBalance: this.props.total,
      });
    }

    if (prevProps.isPickup !== this.props.isPickup) {
      let fullfilment = this.state.fullfilment;

      fullfilment.type = this.props.isPickup ? "PICKUP" : "SHIPMENT";
      fullfilment.state = "PROPOSED";

      if (this.props.isPickup) {
        fullfilment.pickup_details = {};
        fullfilment.pickup_details.recipient =
          fullfilment.shipment_details.recipient;
        fullfilment.pickup_details.recipient.address = null;
        fullfilment.shipment_details = null;
        this.setState({
          address_line_1: "",
          address_line_2: "",
          locality: "",
          sublocality: "",
          postal_code: "",
        });
      } else {
        fullfilment.shipment_details = {};
        fullfilment.shipment_details.recipient =
          fullfilment.pickup_details.recipient;
        fullfilment.pickup_details = null;
      }
      this.setState({
        fullfilment: fullfilment,
      });
    }
  }

  updateCustomerInfo(event, type, isAddress = false) {
    let fullfilment = this.state.fullfilment;
    let value = event.target.value;

    if (
      fullfilment[
        this.props.isPickup ? "pickup_details" : "shipment_details"
      ] == null
    ) {
      fullfilment[this.props.isPickup ? "pickup_details" : "shipment_details"] =
        {};
    }

    if (this.props.isPickup) {
      if (fullfilment.pickup_details.recipient == null) {
        fullfilment.pickup_details.recipient = {};
      }
      fullfilment.pickup_details.recipient[type] = value;
    } else {
      if (fullfilment.shipment_details.recipient == null) {
        fullfilment.shipment_details.recipient = {};
      }

      if (isAddress) {
        this.setState({
          [type]: value,
        });
        if (fullfilment.shipment_details.recipient.address == null) {
          fullfilment.shipment_details.recipient.address = {};
        }
        fullfilment.shipment_details.recipient.address[type] = value;
      } else {
        fullfilment.shipment_details.recipient[type] = value;
      }
    }

    console.log(fullfilment);

    if (this.props.fullfilmentCallback != null)
      this.props.fullfilmentCallback(fullfilment);

    this.setState({
      fullfilment: fullfilment,
    });
  }

  clearError() {
    this.setState({ error: null });
  }

  setError(errorMessage) {
    this.setState({ error: errorMessage });
  }

  async createPayment(token, oderId, remainingBalance, paymentType) {
    let shippingItem = this.props.shippingItem;
    const body = JSON.stringify({
      paymentSourceId: token,
      order: !this.props.isPickup
        ? { ...this.props.orderItems, shippingItem }
        : this.props.orderItems,
      fullfilment: this.state.fullfilment,
      orderId: oderId,
      remainingBalance: remainingBalance,
      paymentType: paymentType,
    });

    const paymentResponse = await fetch("/giftshop/cart/payment", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body,
    })
      .then((response) => response.json())
      .then((data) => {
        console.log("Payment Results: ", data);
        if (data.error == null) {
          return data;
        } else {
          console.log("Payment Error:");
          console.log(data.error);
          return data;
        }
      });
    return paymentResponse;
  }

  getStateOptions() {
    let menuItems = [];
    Object.keys(states).forEach((key) => {
      menuItems.push(<MenuItem value={key}>{states[key]}</MenuItem>);
    });
    return menuItems;
  }

  setPickupTime(time) {
    console.log(time);
    let f = this.state.fullfilment;
    f.pickup_details.pickup_at = time;

    this.setState({
      fullfilment: f,
    });
  }

  handlePaymentOptionChange(event) {
    const {
      target: { value },
    } = event;
    this.setState({
      paymentType: value,
    });
  }

  render() {
    return (
      <Fragment>
        <Modal message={this.state.error} onClose={this.clearError} />
        {this.state.isLoading ? <Loading /> : <></>}
        <CollapsedContainer
          isCollapsed={this.props.checkoutState != "shipping"}
          label="Shipping/Pickup"
          content={
            <Fragment>
              <div>
                <TextField
                  required
                  id="outlined-required"
                  label="Full Name"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="large"
                  onChange={(event) =>
                    this.updateCustomerInfo(event, "display_name")
                  }
                />
                <TextField
                  required
                  id="outlined-required"
                  label="Email"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="large"
                  onChange={(event) =>
                    this.updateCustomerInfo(event, "email_address")
                  }
                />
                <TextField
                  required
                  id="outlined-required"
                  label="Phone"
                  type="phone"
                  autoComplete="phone"
                  variant="outlined"
                  fullWidth
                  margin="normal"
                  size="large"
                  onChange={(event) =>
                    this.updateCustomerInfo(event, "phone_number")
                  }
                />
                {!this.props.isPickup ? (
                  <Fragment>
                    <TextField
                      required
                      id="outlined-required"
                      label="Street Address"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "address_line_1", true)
                      }
                      value={this.state.address_line_1}
                    />
                    <TextField
                      required
                      id="outlined-required"
                      label="Apartment/Unit Number"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "address_line_2", true)
                      }
                      value={this.state.address_line_2}
                    />
                    <TextField
                      required
                      id="outlined-required"
                      label="City"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "locality", true)
                      }
                      value={this.state.locality}
                    />
                    <InputLabel id="state-label">State</InputLabel>
                    <Select
                      labelId="state-label"
                      required
                      autoComplete="address-level1"
                      label="State"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "sublocality", true)
                      }
                      value={this.state.sublocality}
                    >
                      {this.getStateOptions()}
                    </Select>
                    <TextField
                      required
                      id="outlined-required"
                      label="Zip"
                      type="postal-code"
                      autoComplete="postal-code"
                      variant="outlined"
                      fullWidth
                      margin="normal"
                      size="large"
                      onChange={(event) =>
                        this.updateCustomerInfo(event, "postal_code", true)
                      }
                      value={this.state.postal_code}
                    />
                  </Fragment>
                ) : (
                  <PickupSelector
                    pickupTimeCallback={this.setPickupTime.bind(this)}
                  />
                )}
              </div>
            </Fragment>
          }
        />
        <CollapsedContainer
          isCollapsed={this.props.checkoutState != "payment"}
          label="Payment"
          content={
            <Fragment>
              <div className="square-container">
                {this.state.incompletePayment ? (
                  <p className="heading">
                    Remaining Amount: $
                    {(this.state.remainingBalance / 100.0).toFixed(2)}
                  </p>
                ) : (
                  <p className="heading">
                    Order Total: ${(this.state.orderTotal / 100.0).toFixed(2)}
                  </p>
                )}
                <p className="heading">
                  If you would like to use a gift card, please enter the gift
                  card information first.
                </p>
                <FormControl sx={{ m: 1, width: "100%", mt: 3 }}>
                  <p className="heading">Select payment Type</p>
                  <Select
                    disabled={this.state.incompletePayment}
                    value={this.state.paymentType}
                    onChange={this.handlePaymentOptionChange}
                    input={<OutlinedInput />}
                    MenuProps={PaymentOptionProps}
                    inputProps={{ id: "payment-select" }}
                  >
                    {AllowedPaymentOptions.map((name) => (
                      <MenuItem key={name} value={name}>
                        {name}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                {this.state.isLoading ? (
                  <p>Processing Payment...</p>
                ) : (
                  <SquarePaymentForm
                    sandbox
                    applicationId={appId}
                    locationId={locationId}
                    cardTokenizeResponseReceived={async (
                      tokenResp,
                      verifiedBuyer
                    ) => {
                      if (tokenResp.status != "OK") {
                        console.error("Tokenization failed");
                        return;
                      }

                      this.setState({ isLoading: true });

                      var paymentResults = await this.createPayment(
                        tokenResp.token,
                        this.state.orderId,
                        this.state.remainingBalance,
                        this.state.paymentType
                      );
                      console.log("Results Payment Results");
                      console.log(paymentResults);
                      this.setState({ isLoading: false });
                      if (paymentResults.error) {
                        console.error("Payment Failed");
                        this.setState({ error: paymentResults.msg[0].detail });
                        return;
                      }

                      if (paymentResults.customer_email) {
                        alert(
                          `Payment Successful! Email: ${paymentResults.customer_email}`
                        );
                        this.setState({
                          remainingBalance: 0.0,
                        });

                        // Refresh Page
                        window.location.replace(
                          "/giftshop/confirmation?id=" + paymentResults.id
                        );
                      } else {
                        this.setState({
                          orderId: paymentResults.orderId,
                          remainingBalance: paymentResults.remainingBalance,
                          incompletePayment: true,
                          paymentType: "Credit Card",
                          isLoading: false,
                        });
                      }
                    }}
                    createPaymentRequest={() => ({
                      countryCode: "US",
                      currencyCode: "USD",
                      total: {
                        amount: this.state.remainingBalance
                          ? (this.state.remainingBalance / 100.0).toFixed(2)
                          : "",
                        label: "Total",
                      },
                    })}
                  >
                    {this.state.paymentType == "Apple Pay" ? (
                      <>
                        <ApplePay />
                      </>
                    ) : (
                      <></>
                    )}
                    {this.state.paymentType == "Google Wallet" ? (
                      <>
                        <GooglePay />
                      </>
                    ) : (
                      <></>
                    )}
                    {this.state.paymentType == "Credit Card" ? (
                      <>
                        <CreditCard
                          buttonProps={{
                            css: {
                              backgroundColor: "#009cab",
                              fontSize: "14px",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#8e1cff",
                              },
                            },
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                    {this.state.paymentType == "Gift Card" ? (
                      <>
                        <p className="heading">
                          Note: If the gift card does not cover the whole
                          amount, you be prompted to pay the remaining balance
                          with a credit card.
                        </p>
                        <GiftCard
                          buttonProps={{
                            css: {
                              backgroundColor: "#009cab",
                              fontSize: "14px",
                              color: "#fff",
                              "&:hover": {
                                backgroundColor: "#8e1cff",
                              },
                            },
                          }}
                        />
                      </>
                    ) : (
                      <></>
                    )}
                  </SquarePaymentForm>
                )}
              </div>
            </Fragment>
          }
        />
      </Fragment>
    );
  }
}

export default PaymentForm;
